/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Category_WorkoutInputs */

const en_us2_community_category_workout = /** @type {(inputs: Community_Category_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout`)
};

const pt_br2_community_category_workout = /** @type {(inputs: Community_Category_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino`)
};

const es_419_community_category_workout = /** @type {(inputs: Community_Category_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamiento`)
};

const pt_pt2_community_category_workout = /** @type {(inputs: Community_Category_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino`)
};

const fr_fr2_community_category_workout = /** @type {(inputs: Community_Category_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance`)
};

const de_de2_community_category_workout = /** @type {(inputs: Community_Category_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training`)
};

const it_it2_community_category_workout = /** @type {(inputs: Community_Category_WorkoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento`)
};

/**
* | output |
* | --- |
* | "Workout" |
*
* @param {Community_Category_WorkoutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_category_workout = /** @type {((inputs?: Community_Category_WorkoutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Category_WorkoutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_category_workout(inputs)
	if (locale === "es-419") return es_419_community_category_workout(inputs)
	if (locale === "pt-PT") return pt_pt2_community_category_workout(inputs)
	if (locale === "fr-FR") return fr_fr2_community_category_workout(inputs)
	if (locale === "de-DE") return de_de2_community_category_workout(inputs)
	if (locale === "it-IT") return it_it2_community_category_workout(inputs)
	return en_us2_community_category_workout(inputs)
});
export { community_category_workout as "community.category_workout" }